import React, { Component } from "react";
import {
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Button, 
  Modal, 
  Col,
  Panel,
  OverlayTrigger,
  Tooltip
 } from "react-bootstrap";
import './UnitDetail.css';
import { invokeApig } from "../../libs/awsLib";

export class UnitDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      unit: null
    };
  }

  getUnit() {
    return invokeApig({
      path: `/unit/${this.props.unitId}`
    });
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  handleShow = async event =>{
    event.preventDefault();
    try {
      const results = await this.getUnit();
      this.setState({ unit: results, show: true });
    } catch (e) {
      alert(e);
    }
  }

  renderUnit(){
    return(
      <Form horizontal> 
	    <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Número Interno</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.internalNumber}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Patente</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.licensePlate}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Vin</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.vin}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Marca</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.brand}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Modelo</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.model}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Año</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.year}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Límite de Velocidad</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.speedLimit}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Estado</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.status}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Fecha de creación</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.creationDate}</FormControl.Static></Col>
        </FormGroup>
        <FormGroup>
	      <Col componentClass={ControlLabel} sm={4}>Última actualización</Col>
	      <Col sm={8}><FormControl.Static>{this.state.unit.lastUpdateDate}</FormControl.Static></Col>
        </FormGroup>
	    <Panel defaultExpanded={false}>
          <Panel.Heading>
          	Historial de cambios <Panel.Toggle componentClass="a" className="showHistory">Ver historial</Panel.Toggle>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              {
              this.state.unit.changeHistory.map(function(history, index){
            	return (
            	  <div key={index}>
            	    <Col sm={5}><FormControl.Static><b>{history.dateFormat}</b></FormControl.Static></Col>
            	    <Col sm={7}><FormControl.Static><b>{history.user}</b></FormControl.Static></Col>
            	    <Col sm={12}><FormControl.Static>{history.change}</FormControl.Static></Col>
        		  </div>
        		)
        	  })
              }
            </Panel.Body>
    	  </Panel.Collapse>
        </Panel>
      </Form>
    );
  }

  render() {
    const tooltipDetail = (<Tooltip id="tooltipDetail"><strong>Ver Detalles</strong></Tooltip>);
    return (
      <div>
        <OverlayTrigger placement="right" overlay={tooltipDetail}>
	        <a onClick={this.handleShow} href="#unit">{this.props.unitInternalNumber}</a>
        </OverlayTrigger>
          <Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Datos del vehículo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.unit && this.renderUnit() }
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Cerrar</Button>
            </Modal.Footer>
          </Modal>
    </div>
    );
  }
}

export default UnitDetail


// WEBPACK FOOTER //
// ./src/containers/unit/UnitDetail.js